import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { Observable, from } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private cachedToken: string | null = null;

  constructor(private keycloakService: KeycloakService) {}

  initToken(): Observable<string> {
    return from(this.keycloakService.getToken()).pipe(
      catchError((error) => {
        console.error('Errore nel recupero del token', error);
        throw error;
      }),
      tap((token) => {
        this.cachedToken = null;
        localStorage.setItem('token', token);
      })
    );
  }

  getToken(): string | null {
    if (!this.cachedToken) {
      this.cachedToken = localStorage.getItem('token');
    }
    return this.cachedToken;
  }
}
